import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { UppBaseModule } from '@unpispas/upp-base';
import { UppWdgtModule } from '@unpispas/upp-wdgt';
import { UppDataModule } from '@unpispas/upp-data';

import { UppLoginPageComponent } from '../components/login-page/upp-login';
import { UppRegistryPageComponent } from '../components/registry-page/upp-registry';
import { UppRecoveryPageComponent } from '../components/recovery-page/upp-recovery';
import { UppLoginComponent } from '../components/login/upp-login';

@NgModule({
  declarations: [
    UppLoginPageComponent,
    UppRegistryPageComponent,
    UppRecoveryPageComponent,
    UppLoginComponent
  ],
  imports: [
    CommonModule, 
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    UppBaseModule,
    UppWdgtModule,
    UppDataModule
  ],
  exports: [
    UppLoginComponent
  ],
  providers: [],  
  
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]  
})
export class FeatureLoginModule {}
